import * as Y from 'yjs'

export function fromYMapToJS(yMap) {
  const jsObj = {}
  for (const [key, value] of yMap.entries()) {
    if (value instanceof Y.Array) {
      jsObj[key] = value.toArray()
    } else {
      jsObj[key] = value
    }
  }
  return jsObj
}

export function toYMapFromJS(pathObj) {
  const yMap = new Y.Map()
  for (const [key, value] of Object.entries(pathObj)) {
    if (key === 'points') {
      const yArr = new Y.Array()
      yArr.push(value)
      yMap.set(key, yArr)
    } else {
      yMap.set(key, value)
    }
  }
  return yMap
}
